import { render } from "./MiNTNewsDetailMobile.vue?vue&type=template&id=3444543a&scoped=true"
import script from "./MiNTNewsDetailMobile.vue?vue&type=script&lang=js"
export * from "./MiNTNewsDetailMobile.vue?vue&type=script&lang=js"

import "./MiNTNewsDetailMobile.vue?vue&type=style&index=0&id=3444543a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444543a"]])

export default __exports__